import { render, staticRenderFns } from "./CreateFilter.vue?vue&type=template&id=6ec5e70a&"
import script from "./CreateFilter.vue?vue&type=script&lang=js&"
export * from "./CreateFilter.vue?vue&type=script&lang=js&"
import style0 from "./CreateFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports